import React from "react";
import { Select, Modal } from "antd";
import {
  COMMON_CONSTANT,
  DYNAMIC_REPORT_TYPE,
  KEY,
  lang,
} from "./common.const";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { format } from "react-string-format";
import moment from "moment";
import { isString, isObject, isEmpty as isEmptyLodash } from "lodash";
import DynamicChart from "../component/DynamicChart/index2";
import OverlapChart from "../component/DynamicChart/OverLapChart";
import html2canvas from "html2canvas";
import ExcelJS from "exceljs";
const { Option } = Select;

export const showMessage = (type, msg, callbackCancel) => {
  Modal.destroyAll();
  switch (type) {
    case KEY.ERROR:
      Modal.error({
        centered: true,
        title: lang.ERROR,
        content: msg,
        onOk: callbackCancel,
      });
      break;
    case KEY.WARMING:
      Modal.warning({
        centered: true,
        icon: <QuestionCircleOutlined />,
        title: lang.WARMING,
        content: msg,
        onOk: callbackCancel,
      });
      break;
    case KEY.INFO:
      Modal.success({
        centered: true,
        title: lang.SUCCESS,
        content: msg,
        onOk: callbackCancel,
      });
      break;
    default:
      break;
  }
};

export const showMessageChange = (
  callbackOk,
  msg = COMMON_CONSTANT.BOM_C001
) => {
  Modal.destroyAll();
  Modal.confirm({
    centered: true,
    icon: <QuestionCircleOutlined />,
    title: lang.CONFIRM,
    content: msg, // default message confirm delete?
    okText: lang.OK,
    cancelText: lang.CANCEL,
    onOk: callbackOk,
  });
};


export const showMessageSuccess = (
  callbackOk,
  msg = COMMON_CONSTANT.BOM_C003
) => {
  Modal.destroyAll();
  Modal.confirm({
    centered: true,
    icon: <QuestionCircleOutlined />,
    title: "確認",
    content: msg, // default message confirm delete?
    okText: lang.OK,
    cancelText: lang.CANCEL,
    onOk: callbackOk,
  });
};

export const enterSearch = (funcSearch) => {
  return {
    onKeyDown: (e) => {
      if (e.keyCode === 13) {
        funcSearch();
      }
    },
  };
};

export const selectSearch = {
  filterOption: (input, option) =>
    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
};

export const encodeSearchText = (value) => {
  return value;
};

export const checkCharacter = (input) => {
  return checkSpecialCharacterSingle(input);
};

export const checkSpecialCharacterSingle = (input) => {
  const regEx = /^[^!@#$%^&*+=?><~"",|}{]+$/;

  if (!regEx.test(input.value)) {
    return false;
  }
  return true;
};

// check checklist exist
export const isChecklistDeleted = (CHECKLIST_ID) => {
  const changedFlag = false;
  //is checklist deleted ?
  // $.ajax({
  //     url: _spPageContextInfo.webServerRelativeUrl + "/_api/web/lists/getbytitle('Checklist')/Items?$filter=" + query,
  //     type: "GET",
  // }).done(function (data) {
  // if (data.d.results && data.d.results.length > 0) {
  //     changedFlag = true;
  // } else {
  //     changedFlag = false;
  // }
  // }).fail(function (xhr) {
  //     console.log(xhr.status + ': ' + xhr.statusText);
  // });
  return changedFlag;
};

export const validateGroup = (input) => {
  // HTML
  const newGroupName = input.value;
  if (!newGroupName || newGroupName.length > 255) {
    return false;
  } else {
    return checkSpecialCharacterSingle(input);
  }
};

// Loading
export const openLoadingSpinner = (funcShow) => {
  funcShow(true);
};

export const closeLoadingSpinner = (funcShow) => {
  setTimeout(() => {
    funcShow(false);
  }, 500);
};

//  Render Option for Search
export const renderOptionForSearch = (options) => {
  if (options && options.length > 0) {
    return options.map((e) => (
      <Option value={e.key || e.id} key={e.key || e.id}>
        {e.value || e.name}
      </Option>
    ));
  }
};

//  Render Option
export const renderOption = (options, optionBlank = true, lengthText) => {
  if (options && options.length > 0) {
    return (
      <>
        {optionBlank && <Option value="" key="blank"></Option>}
        {options.map((e) => {
          let optionText = e.value || e.name;
          if (lengthText && typeof lengthText === "number") {
            if (optionText.length > lengthText) {
              optionText = optionText.substring(0, lengthText) + "...";
            }
          }
          return (
            <Option value={e.key || e.id} key={e.key || e.id}>
              {optionText}
            </Option>
          );
        })}
      </>
    );
  }
};

//  Render Option one Check
export const renderOptionOneCheck = (
  options,
  optionBlank = true,
  { value, list = [] }
) => {
  if (options && options.length > 0) {
    return (
      <>
        {optionBlank && <Option value="" key="blank"></Option>}
        {options.map((e) => {
          const key = e.key || e.id || e.code;
          return (
            <Option
              value={key}
              key={key}
              disabled={list.includes(key) && key !== value}
            >
              {e.value || e.name}
            </Option>
          );
        })}
      </>
    );
  }
};

//  Render Option
export const renderOptionHTML = (options, optionBlank = true) => {
  if (options && options.length > 0) {
    return (
      <>
        {optionBlank && <option value="" key="blank"></option>}
        {options.map((e) => (
          <option value={e.key || e.id} key={e.key || e.id}>
            {e.value || e.name}
          </option>
        ))}
      </>
    );
  }
};

export const renderOptionInputCL = (item) => {
  let arrayOption = item.split(";");
  let array = [];
  array.push(<Select.Option key={0} value={null} />);
  arrayOption.forEach((item, index) =>
    array.push(
      <Select.Option key={index + 1} value={item}>
        {item}
      </Select.Option>
    )
  );
  return array;
};

// Case response
export const statusRes = (res) => {
  let data = {
    success: false,
    msg: "",
  };
  // Case success
  switch (res.status) {
    case 200:
      data.success = true;
      break;
    case 400:
      data.success = false;
      break;
    case 401:
      data.success = false;
      break;
    default:
      data.success = false;
      break;
  }

  return data.success;
};
// Case catch
export const MSG_CATCH = (msg) =>
  window.navigator.onLine
    ? msg || COMMON_CONSTANT.BOM_E008
    : COMMON_CONSTANT.BOM_E004;

// Input dateTime
const INPUT_TIME = (e, type) => {
  let lengthInput;
  switch (type) {
    case "week":
      lengthInput = 7;
      break;
    case "year":
      lengthInput = 4;
      break;
    default:
      lengthInput = 10; // DATE
  }
  let val = e.target.value;

  if (
    e.keyCode === 13 || //  enter
    e.keyCode === 9 || //  tab
    e.keyCode === 46 || //  delete
    e.keyCode === 8 || //  backspace
    (e.keyCode >= 37 && e.keyCode <= 40) || // Up down ...
    ((e.ctrlKey || e.metaKey) &&
      (e.which === "65" || e.which === "88" || e.which === "86"))
  ) {
    // Always
  } else if (
    // Typing
    ((e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode >= 96 && e.keyCode <= 105) || // 0-9
      e.keyCode === 111 ||
      e.keyCode === 191) && // slash "/"
    val.length < lengthInput &&
    !e.shiftKey
  ) {
    if (val.length === 4 || val.length === 7) {
      /// Date
      e.target.value = val + "/";
      if (e.keyCode === 111 || e.keyCode === 191) {
        // slash "/")
        e.preventDefault();
        return false;
      }
    } else {
      // Typing
      if (e.keyCode === 111 || e.keyCode === 191) {
        e.preventDefault();
        return false;
      }
    }
  } else {
    e.preventDefault();
    return false;
  }
};

export const INPUT_DATE = {
  onKeyDown: (e) => {
    INPUT_TIME(e);
  },
  onBlur: (e) => {
    //   // e.target.value = '1111/01/01';
    //   // e.value = '1111/01/01';
    //   // var ev2 = new Event('change', e);
    //   // e.target.dispatchEvent(ev2);
    //   // // debugger;
    //   // e.preventDefault();
    //   // return false;
  },
};

export const INPUT_MONTH = {
  onKeyDown: (e) => {
    INPUT_TIME(e, "week");
  },
};

export const INPUT_YEAR = {
  onKeyDown: (e) => {
    INPUT_TIME(e, "year");
  },
};

// Remove item from array
export const removeItemArr = (array, item) => {
  const index = array.indexOf(item);
  if (index !== -1) {
    array.splice(index, 1);
  }
  return array;
};

// Format Column CheckItemCode
export const formatCheckItemCode = (text, cOrder = 0) => {
  let temp = "";
  if (text) {
    let timeCheck = "";
    if (cOrder && cOrder !== 0) {
      timeCheck = format("#T{0}", cOrder);
    }
    temp = format(COMMON_CONSTANT.NEW_DATA_TEMPLATE_CODE, text, timeCheck);
  }
  return temp;
};

export const isImage = (fileName) => {
  let dotExt = getDotFile(fileName);
  if (
    dotExt === "png" ||
    dotExt === "jpg" ||
    dotExt === "jpeg" ||
    dotExt === "bmp" ||
    dotExt === "gif" ||
    dotExt === "ico"
  ) {
    return true;
  }
  return false;
};

export const hasPreview = (fileName) => {
  let dotExt = getDotFile(fileName);
  if (
    dotExt === "pdf" ||
    dotExt === "txt" ||
    dotExt === "sql" ||
    dotExt === "html" ||
    dotExt === "js"
  ) {
    return true;
  }
  return false;
};

export const getNameFile = (name) => {
  return name.split(".").slice(0, -1).join(".");
};

export const getDotFile = (name) => {
  return name.split(".").pop();
};

export const saveFile = (res) => {
  // Get file name
  let headerLine = res.headers["content-disposition"];
  let startFileNameIndex = headerLine.indexOf("=") + 1;
  let endFileNameIndex = headerLine.lastIndexOf(";");
  let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
  let fileNameO = decodeURIComponent(filename);

  // Create link
  const blob = new Blob([res.data]);
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.target = "_blank";
  link.download = fileNameO;
  link.click();
};

export const getRange = (normalLowerControlValue, normalUpperControlValue) => {
  normalLowerControlValue =
    normalLowerControlValue === null ? null : String(normalLowerControlValue); // Fix for case 0 === false
  normalUpperControlValue =
    normalUpperControlValue === null ? null : String(normalUpperControlValue); // Fix for case 0 === false
  let range = "";
  if (
    normalLowerControlValue &&
    normalLowerControlValue !== "" &&
    normalUpperControlValue &&
    normalUpperControlValue !== ""
  ) {
    range += normalLowerControlValue + " ~ " + normalUpperControlValue;
  } else if (normalLowerControlValue && normalLowerControlValue !== "") {
    range += normalLowerControlValue + " ~ ";
  } else if (normalUpperControlValue && normalUpperControlValue !== "") {
    range += " ~ " + normalUpperControlValue;
  } else {
    range += "-";
  }
  return range;
};

export const hwEnabled = (dataRow) => {
  return !dataRow.workingStatus || Number(dataRow.workingStatus) === 1;
};

// Show mark
export const sttMachine = (dataRow) => {
  let sttTabLeft;
  if (hwEnabled(dataRow)) {
    switch (dataRow.status) {
      case KEY.ERROR:
        sttTabLeft = "error";
        break;
      case KEY.WARMING:
        sttTabLeft = "warning";
        break;
      case KEY.DONE:
        sttTabLeft = "done";
        break;
      default:
        sttTabLeft = "info";
        break;
    }
  } else {
    sttTabLeft = "disabled"; // Disable machine
  }

  return sttTabLeft;
};

export const markMachine = (dataRow) => {
  let stt;
  if (hwEnabled(dataRow)) {
    switch (dataRow.status) {
      case KEY.ERROR:
        stt = "error";
        break;
      case KEY.WARMING:
        stt = "warning";
        break;
      case KEY.DONE:
        stt = "done";
        break;
      default:
        stt = "default";
        break;
    }
  } else {
    stt = "disabled"; // Disable machine
  }

  return <span className={"ellipse-mark ellipse-mark-" + stt}></span>;
};

export const isHeadOffice = () => {
  const j = JSON.parse(localStorage.getItem(KEY.LOC_USER_INFO));
  return Number(j.role) === Number(KEY.MENU_ADMIN);
};
export const isAdminOffice = () => {
  const j = JSON.parse(localStorage.getItem(KEY.LOC_USER_INFO));
  return Number(j.role) === Number(KEY.MENU_ADMIN_OFFICE);
};
export const isGroupManager = () => {
  const j = JSON.parse(localStorage.getItem(KEY.LOC_USER_INFO));
  return Boolean(j.isGroupManager);
};

export const sttCellInput = (val, err) => {
  return err ? "red" : "";
};

// Url search to object param
export const getQuerySearch = () => {
  const search = new URLSearchParams(window.location.search);
  const objParam = {};
  for (let [k, v] of search.entries()) {
    objParam[k] = v;
  }
  return objParam;
};

export const int2DateString = (int, format = KEY.DATE_DEFAULT) => {
  return int ? moment(int).format(format) : "";
};

export const getTxtValue = (str) => (str ? str : null);
export const getDateValue = (str) =>
  getTxtValue(str) ? moment(Number(getTxtValue(str))) : null;
export const getUserValue = (str) => (str ? str.split(",") : []);
export const getCheckboxValue = (str) => str === "true";
// Push object to url
export const pushObject2Query = (objSearch) => {
  // Object to string query
  const paramString = Object.keys(objSearch)
    .filter((k) => objSearch[k] !== null)
    .map((key) => {
      if (moment.isMoment(objSearch[key])) {
        // Date
        return (
          key + "=" + (objSearch[key] === null ? "" : objSearch[key].valueOf())
        );
      } else {
        // Other
        return (
          key +
          "=" +
          (objSearch[key] === null ? "" : encodeURIComponent(objSearch[key]))
        );
      }
    })
    .join("&");
  // push to url
  window.history.replaceState(
    null,
    null,
    paramString ? "?" + paramString : "?"
  );
};

// push or replace key
export const pushObject2QueryReplace = (obj) => {
  const queySearch = getQuerySearch();
  const objSearch = { ...queySearch, ...obj };
  // Object to string query
  const paramString = Object.keys(objSearch)
    .filter((k) => objSearch[k] !== null)
    .map((key) => {
      if (moment.isMoment(objSearch[key])) {
        // Date
        return (
          key + "=" + (objSearch[key] === null ? "" : objSearch[key].valueOf())
        );
      } else {
        // Other
        return (
          key +
          "=" +
          (objSearch[key] === null ? "" : encodeURIComponent(objSearch[key]))
        );
      }
    })
    .join("&");
  // push to url
  window.history.replaceState(
    null,
    null,
    paramString ? "?" + paramString : "?"
  );
};
export const inputNumberRequired = (txt) => {
  return (
    txt === undefined ||
    txt === null ||
    isNaN(txt) ||
    String(txt).trim().length === 0 ||
    Number(String(txt).trim()) === 0
  );
};
export const txtRequired = (txt) => {
  return txt === undefined || txt === null || String(txt).trim().length === 0;
};

export const isEmpty = (s) => {
  return s === undefined || s === null || s.length === 0;
};

export const getUserName = () => {
  const j = JSON.parse(localStorage.getItem(KEY.LOC_USER_INFO));
  return j.userName;
};

// Render sort
export const renderSortColumn = (arr, onSortColumn) => {
  return arr.map((col, index, arr) => {
    //
    col.title = (
      <div className="white-space" style={{ whiteSpace: "pre" }}>
        {/* Select */}
        <Select
          size="small"
          className="mr10"
          value={index}
          onChange={(v) => {
            onSortColumn(v, index);
          }}
        >
          {arr.map((l, i) => {
            return <Select.Option value={i}>{i + 1}</Select.Option>;
          })}
        </Select>
        {/* Name */}
        <span className="white-space" style={{ whiteSpace: "pre" }}>
          {col.name}
        </span>
      </div>
    );
    return col;
  });
};
// Event sort column
export const onSortColumn = (
  indexNew,
  indexOld,
  [columnsItem_draft, setColumnsItem_draft]
) => {
  const col = columnsItem_draft[indexOld];
  // First column: 0 -> indexOld
  const firstCol = columnsItem_draft.slice(0, indexOld);
  // Last column: indexOld -> End
  const lastCol = columnsItem_draft.slice(indexOld + 1);
  // Push to indexNew
  const newCols = [...firstCol, ...lastCol];
  newCols.splice(indexNew, 0, col);
  // Set
  setColumnsItem_draft(newCols);
};
// Render default
export const renderDefaultColumn = (arr) => {
  return arr.map((col) => {
    col.title = col.name;
    return col;
  });
};

export const saveSortColumn_local = (key, arr) => {
  const userName = getUserName();
  const obj = JSON.parse(localStorage.getItem(KEY.SORT_TABLE)) || {};
  obj[userName] = { ...obj[userName] };
  obj[userName][key] = arr;
  localStorage.setItem(KEY.SORT_TABLE, JSON.stringify(obj));
};
export const getSortColumn_local = (key) => {
  const userName = getUserName();
  const obj = JSON.parse(localStorage.getItem(KEY.SORT_TABLE)) || {};
  return obj && obj[userName] && obj[userName][key] ? obj[userName][key] : null;
};
export const checkInteger = (v, callback) => {
  if (("" + v).includes(".")) {
    return;
  }
  callback();
};

export const handleCatchError = (err) => {
  let msg = MSG_CATCH();
  if (
    !isEmptyLodash(err.response) &&
    isString(err.response.data) &&
    !isEmptyLodash(err.response.data)
  ) {
    msg = err.response.data;
  }
  if (
    !isEmptyLodash(err.response) &&
    isObject(err.response.data) &&
    isString(err.response.data.msg)
  ) {
    msg = err.response.data.msg;
  }
  showMessage(KEY.ERROR, msg);
};
export const renderChartByType = (type, props) => {
  switch (String(type)) {
    case DYNAMIC_REPORT_TYPE.NORMAL || DYNAMIC_REPORT_TYPE.IOT: {
      return <DynamicChart {...props} />;
    }
    case DYNAMIC_REPORT_TYPE.OVERLAP: {
      return <OverlapChart {...props} />;
    }
    default: {
      return <DynamicChart {...props} />;
    }
  }
};

export const checkErrorDuplicateFileName = (
  fileName,
  listFile = [],
  key = "name"
) => {
  const index = listFile.findIndex((file) => file[key] == fileName);
  if (index >= 0) {
    Modal.error({
      title: lang.ERROR,
      content: "ル存在したファイ名",
      centered: true,
    });
    return true;
  }
  return false;
};

// DOWNLOAD EXCEL
export const saveFileExcel = async (res, idImage) => {
  const blob = new Blob([res.data]);

  const reader = new FileReader();
  reader.onload = async (event) => {
    const data = new Uint8Array(event.target.result);
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(data);
    const worksheet = workbook.addWorksheet("Chart Image");

    const element = document.getElementById(idImage);
    if (element) {
      const canvas = await html2canvas(element);
      const imgData = canvas.toDataURL("image/jpeg");
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      const imageId = workbook.addImage({
        base64: imgData,
        extension: "jpeg",
      });

      worksheet.addImage(imageId, {
        tl: { col: 2, row: 2 },
        ext: { width: canvasWidth * 0.75, height: canvasHeight * 0.75 },
      });

      const updatedExcelBuffer = await workbook.xlsx.writeBuffer();
      const updatedExcelBase64 = arrayBufferToBase64(updatedExcelBuffer);
      saveFileExcelFromBase64(updatedExcelBase64, "file_with_image.xlsx");
    }
  };
  reader.readAsArrayBuffer(blob);
};
function arrayBufferToBase64(buffer) {
  const binary = String.fromCharCode.apply(null, new Uint8Array(buffer));
  return window.btoa(binary);
}
const saveFileExcelFromBase64 = (base64Data, fileName) => {
  const byteCharacters = atob(base64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }

  const blob = new Blob(byteArrays, {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  link.download = fileName || "file.xlsx";
  link.click();

  window.URL.revokeObjectURL(url);
};

function getLengthWithJapaneseWeight(str) {
  let length = 0;

  for (let i = 0; i < str.length; i++) {
    const char = str[i];
    if (/[\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}]/u.test(char)) {
      length += 2;
    } else {
      length += 1;
    }
  }

  return length;
}
export const formatSheet = (worksheet = {}) => {
  const columns = worksheet.columns || [];

  columns.forEach((column) => {
    let maxLength = 0;
    column.eachCell({ includeEmpty: true }, (cell) => {
      const cellLength = cell.value
        ? getLengthWithJapaneseWeight(cell.value.toString())
        : 0;
      if (cellLength > maxLength) maxLength = cellLength;
    });
    const finalWidth = maxLength + 3;
    column.width = finalWidth <= 40 ? finalWidth : 40;

    if (finalWidth > 40) {
      column.eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = { wrapText: true };
      });
    }
  });
  worksheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.alignment = { horizontal: "left" };
    });
  });
};

const getColumnName = (index) => {
  let columnName = "";
  while (index >= 0) {
    columnName = String.fromCharCode((index % 26) + 65) + columnName;
    index = Math.floor(index / 26) - 1;
  }
  return columnName;
};
export const downloadChartItemImage = async (
  workbook,
  chartItem,
  idChart,
  index = 0,
  isListImage = false
) => {
  const worksheet = workbook.addWorksheet(
    chartItem.reportName || `sheet=${index}`
  );
  const labels = chartItem.labelsDataOfYear  || chartItem.exactLabels || [];

  worksheet.getCell("A1").value = "Date";
  labels.forEach((item, rowIndex) => {
    const cellRef = worksheet.getCell(`A${rowIndex + 2}`);
    cellRef.alignment = { horizontal: "left" };
    cellRef.value = item;
  });

  let listItemData = [];
  if (chartItem.reportType == DYNAMIC_REPORT_TYPE.OVERLAP) {
    listItemData = chartItem.dataOfYear || [];
  } else {
    listItemData = chartItem.series || [];
  }

  listItemData.forEach((seriItem, seriIndex) => {
    const columnName = getColumnName(seriIndex + 1);
    worksheet.getCell(`${columnName}1`).value = seriItem.name;
    seriItem.data.forEach((item, rowIndex) => {
      const cellRef = worksheet.getCell(`${columnName}${rowIndex + 2}`);
      cellRef.value = item;
    });
  });

  formatSheet(worksheet);

  if (!isListImage) {
    const worksheetImage = workbook.addWorksheet(
      chartItem.reportName + "_画像 " || `sheet=${index}`
    );
    const element = document.getElementById(idChart);

    if (element) {
      const canvas = await html2canvas(element);
      const imgData = canvas.toDataURL("image/jpeg");
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const imageId = workbook.addImage({
        base64: imgData,
        extension: "jpeg",
      });
      worksheetImage.addImage(imageId, {
        tl: { col: 2, row: 2 },
        ext: { width: canvasWidth * 0.75, height: canvasHeight * 0.75 },
      });
    }
  }
};

// Handle Chart
export const handleDataChartHelper = (itemUpdate, typeChange) => {
  const itemUpdated = itemUpdate.data[0];
  const dataChart = itemUpdated.data;
  const arrLabels = [];
  const arrData = [];
  const exactLabels = [];
  let hasDataLabel = false;
  dataChart.forEach((line) => {
    // handle line data
    const arrLineValue = [];
    let hasDataValue = false;
    if (line.data.length) {
      const dataLine = line.data;
      dataLine.forEach((itemDayOfLine) => {
        if (!hasDataLabel) {
          let label;
          if (itemDayOfLine.groupTitle && Number(typeChange) !== 2) {
            label = itemDayOfLine.groupTitle;
          } else {
            label = itemDayOfLine.title || "";
          }
          arrLabels.push(label);
          exactLabels.push(itemDayOfLine.title || "");
        }
        if (itemDayOfLine.value !== null) {
          hasDataValue = true;
        }
        const finalValue =
          itemDayOfLine.value == 0 ? 0 : Number(itemDayOfLine.value) || null;
        arrLineValue.push(finalValue);
      });
      hasDataLabel = true;
    }
    const lineData = {
      name: line.checkItemName,
      data: hasDataValue ? arrLineValue : [],
      machineName: line.machineForSiteOfficeName || "",
      color: line.color,
      unit: line.unit,
      min: line.min,
      max: line.max,
      normalLowerControlValue: line.normalLowerControlValue,
      normalUpperControlValue: line.normalUpperControlValue,
    };
    arrData.push(lineData);
  });
  let isHasData = false;
  for (let i = 0; i < arrData.length; i++) {
    if (arrData[i].data.length) {
      isHasData = true;
      break;
    }
  }
  let stringCheckItemName = arrData.map((item) => item.name).join(",");
  if (itemUpdated.data[0] && itemUpdated.data[0].checkItemName) {
    stringCheckItemName = itemUpdated.data[0].checkItemName;
  }
  let machineForSiteOfficeName = "";
  if (itemUpdated.data[0] && itemUpdated.data[0].machineForSiteOfficeName) {
    machineForSiteOfficeName = itemUpdated.data[0].checkItemName;
  }
  const dataItem = {
    id: itemUpdated.id,
    itemCode: itemUpdated.checkItemCode,
    checkItemName: stringCheckItemName,
    labels: arrLabels,
    type: itemUpdated.type,
    machineName: machineForSiteOfficeName || "",
    normalLowerControlValue: itemUpdated.normalLowerControlValue,
    normalUpperControlValue: itemUpdated.normalUpperControlValue,
    min: itemUpdate.min,
    max: itemUpdate.max,
    unit: itemUpdated.unit,
    series: arrData,
    categories: arrLabels,
    isHasData: isHasData,
    reportName: itemUpdated.name,
    checklistType: itemUpdated.checklistType,
    exactLabels,
  };
  return dataItem;
};

export function formatString(str, ...params) {
  return str.replace(/\{(\d+)\}/g, (_, index) => params[index]);
}
